// German for the live turn-activity band.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Answering…': 'Antwortet…',
  'tokens': 'Tokens',
  'tool calls': 'Tool-Aufrufe',
}, 'ChatActivity');
